import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const CATEGORIES = [
  { label: "Medical News", slug: "medical-news" },
  { label: "Doctor Speak", slug: "doctor-speak" },
  { label: "Health Awareness", slug: "health-awareness" },
  { label: "Hospitals", slug: "govt-hospital" },
  { label: "Careers", slug: "recruitment" },
  { label: "Business & Tech", slug: "business-tech" },
  { label: "Podcasts", slug: "podcasts" },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400 border-t border-slate-800" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-14 w-48 overflow-hidden flex items-center justify-center bg-white/10 rounded">
                <img src="https://customer-assets.emergentagent.com/job_doctor-speak-hub/artifacts/thatxx48_Pulse%20Medical%20Media%20Logo%20-%20Smooth%20Blue%20Design.svg" alt="Pulse Medical Media" className="h-[200px] w-auto" style={{marginTop: '18px'}} />
              </div>
            </div>
            <p className="text-sm leading-relaxed font-sans">
              Trusted medical news and awareness platform delivering evidence-based healthcare content to readers worldwide.
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-sans font-semibold text-white text-sm uppercase tracking-[0.15em] mb-4">Categories</h4>
            <ul className="space-y-2">
              {CATEGORIES.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm font-sans hover:text-white transition-colors">
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="font-sans font-semibold text-white text-sm uppercase tracking-[0.15em] mb-4">About</h4>
            <ul className="space-y-2 text-sm font-sans">
              <li>About Us</li>
              <li>Editorial Policy</li>
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
              <li>Contact</li>
              <li>Advertise</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs font-sans text-slate-500">
            &copy; {new Date().getFullYear()} Pulse Medical Media. All rights reserved.
          </p>
          <p className="text-xs font-sans text-slate-500 flex items-center gap-1">
            Made with <Heart className="h-3 w-3 text-red-400" /> for better health awareness
          </p>
        </div>
      </div>
    </footer>
  );
}
